var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_42",
  "data-name": "Ellipse 42",
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#fd7a3b"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Path_74",
  "data-name": "Path 74",
  d: "M147.522,562.36a.489.489,0,0,0-.511.507v6.987a.523.523,0,0,0,1.045,0v-6.987A.517.517,0,0,0,147.522,562.36Z",
  transform: "translate(-137.556 -558.36)",
  fill: "#fff"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_75",
  "data-name": "Path 75",
  d: "M49.543,562.36a.512.512,0,0,0-.511.507v6.987a.523.523,0,0,0,1.045,0v-6.987A.508.508,0,0,0,49.543,562.36Z",
  transform: "translate(-43.532 -558.36)",
  fill: "#fff"
})));
export default __webpack_public_path__ + "static/media/circle-pause.e289824e.svg";
export { SvgComponent as ReactComponent };